import { unloadThisYearData } from './thisyear/unloadthisyear'
import { unloadFutureData } from './futurechoices/unloadfuture'
import { unloadSettings } from './settings/action'
import { unloadSummary } from './summary/action'

export const unloadBMCData = () => dispatch => {
  dispatch(unloadThisYearData())
  dispatch(unloadFutureData())
  dispatch(unloadSettings())
  dispatch(unloadSummary())
}
